import React from 'react';
import { IconButton } from '@material-ui/core';
import { EditOutlined, DeleteOutlined } from '@material-ui/icons';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { OracleDowntimeScheduleDisplay } from './types';
import { hasScheduleStarted, canEditSchedule } from './utility';

interface ActionsRendererProps extends ICellRendererParams<OracleDowntimeScheduleDisplay> {
  onEdit?: (schedule: OracleDowntimeScheduleDisplay) => void;
  onDelete?: (schedule: OracleDowntimeScheduleDisplay) => void;
}

const ActionsRenderer: React.FC<ActionsRendererProps> = ({ data, onEdit, onDelete }) => {
  const handleEdit = () => {
    if (data && onEdit) {
      onEdit(data);
    }
  };

  const handleDelete = () => {
    if (data && onDelete) {
      onDelete(data);
    }
  };

  const showEditButton = data && canEditSchedule(data);
  const showDeleteButton = data && !hasScheduleStarted(data);

  return (
    <>
      {showEditButton && (
        <IconButton size="small" onClick={handleEdit} data-testid="edit-schedule-button">
          <EditOutlined fontSize="small" />
        </IconButton>
      )}
      {showDeleteButton && (
        <IconButton size="small" onClick={handleDelete} data-testid="delete-schedule-button">
          <DeleteOutlined fontSize="small" />
        </IconButton>
      )}
    </>
  );
};

export default ActionsRenderer;
